export default [
  {
    path: "/payments/transaction",
    name: "Transaction",
    component: () =>
      import("@/modules/payments/transactions/views/TransactionList.vue"),
  },
  {
    path: "/payments/settlement",
    name: "Settlement",
    component: () => import("@/modules/payments/settlements/views/SettlementsList.vue"),
  },
  {
    path: "/settlement/edit/:id",
    name: "editSettlements",
    component: () => import("@/modules/payments/settlements/views/Settlement.vue"),
  },
];
